import { render, staticRenderFns } from "./InputRegion.vue?vue&type=template&id=0eaf8bce"
import script from "./InputRegion.vue?vue&type=script&lang=js"
export * from "./InputRegion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports